// Shared contact constants. Single source of truth for the business
// WhatsApp number, previously duplicated as a string literal across
// WhatsAppButton, PlaceDetailModal, CityDetailPage, and QuoteResultPage.
export const WHATSAPP_NUMBER = "919845592920";
